import { useState } from "react"
import classNames from "classnames/bind"
import { Row, Col, Drawer } from "antd"
import { MenuOutlined } from "@ant-design/icons"
import { withTranslation, TFunction } from "react-i18next"
import { Link } from "react-router-dom"
import { ReactComponent as NavbarLogo } from "../../assets/logo-name.svg"
import { Button } from "../../common/Button"
import styles from "./styles.scss"


const cx = classNames.bind(styles)
const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false)

  const toggleButton = () => {
    setVisibility(!visible)
  }

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement
      element.scrollIntoView({
        behavior: "smooth",
      })
      setVisibility(false)
    }
    return (
      <>
        <div className={cx("nav-link-small")}  onClick={() => scrollTo("mission")}>
          <span className={cx("span")}>{t("Mission")}</span>
        </div>
        <div className={cx("nav-link-small")} onClick={() => scrollTo("about")}>
          <span className={cx("span")}>{t("About")}</span>
        </div>
        <div className={cx("nav-link-small")}  onClick={() => scrollTo("services")}>
          <span className={cx("span")}>{t("Services")}</span>
        </div>
        <div
          className={cx("nav-link-small-button")} 
        >
          <span className={cx("span")}>
            <Button onClick={(e) => {scrollTo("contact"); (e.currentTarget as HTMLElement).blur();}}>{t("Contact")}</Button>
          </span>
        </div>
      </>
    )
  }

  return (
    <header className={cx("header-section")}>
      <div className={cx("container")}>
        <Row>
          <div className={cx("main-logo")}>
            <Link to="/" aria-label="homepage">
              <NavbarLogo/>
            </Link>
          </div>

          <div className={cx("notHidden")}>
            <MenuItem />
          </div>
          <div className={cx("burger")} onClick={toggleButton}>
              <MenuOutlined className={cx("outlined")}/>
          </div>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <span className={cx("header-label")} onClick={toggleButton}>
              <Col span={12}>
                <h5 className={cx("menu")}>Menu</h5>
              </Col>
              <Col span={12}>
                <MenuOutlined className={cx("outlined")}/>
              </Col>
            </span>
          </Col>
          <MenuItem />
        </Drawer>
      </div>
    </header>
  )
}

export default withTranslation()(Header)
